<div class="flight-data-wrapper">

    <div class="label-row">
        <div class="icon">
            <app-svg-loader height="18px" [url]="iconURL"></app-svg-loader>
        </div>
        <div class="label">{{label || 'no label provided'}}</div>
    </div>

    <div class="value-row">
        <div *ngIf="!value" class="empty-state">
            <app-data-empty-animation height="28px" width="160px"></app-data-empty-animation>
        </div>
        <div *ngIf="value" class="value">{{value}}</div>
    </div>

</div>